import styled from 'styled-components';

/**
 * Pill-shaped row that hosts the email `<input>` plus an inline `more`
 * action button. The composite control (input + adjacent button) doesn't
 * appear elsewhere yet and uses a custom 6px right inset to make space
 * for the button, so it stays local rather than being lifted into the
 * shared {@link DialogField} family.
 */
export const EmailRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${({ theme: { colors = {} } }) =>
    colors.surfaceContainer ?? '#1F1E27'};
  border: 0;
  border-radius: 999px;
  padding: 4px 6px 4px 20px;
  transition: background 120ms ease;

  &:focus-within {
    background: ${({ theme: { colors = {} } }) =>
      colors.surfaceContainerHigh ?? '#1F2030'};
  }
`;

export const EmailInput = styled.input`
  flex: 1;
  min-width: 0;
  background: transparent;
  border: 0;
  outline: none;
  padding: 10px 0;
  color: ${({ theme: { colors = {} } }) => colors.onSurface ?? '#E6E6F2'};
  font: inherit;
  font-size: 14px;

  &::placeholder {
    color: ${({ theme: { colors = {} } }) =>
      colors.onSurfaceVariant ?? '#C9C5D5'};
  }
`;

export const EmailMoreButton = styled.button`
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme: { colors = {} } }) =>
    colors.surfaceContainerHigh ?? '#1F2030'};
  color: ${({ theme: { colors = {} } }) =>
    colors.onSurfaceVariant ?? '#C9C5D5'};
  border: 0;
  border-radius: 8px;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: color-mix(
      in oklch,
      ${({ theme: { colors = {} } }) =>
        colors.surfaceContainerHigh ?? '#1F2030'}
        90%,
      white
    );
    color: ${({ theme: { colors = {} } }) => colors.onSurface ?? '#E6E6F2'};
  }

  & svg {
    width: 18px;
    height: 18px;
  }
`;
